import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { Location } from 'types';

export const getLocation = async (
  locationId: number
): Promise<Location | undefined> => {
  if (locationId < 1) return;
  const { data } = await axios.get(`/api/locations/${locationId}`);
  return data as Location;
};

type QueryFnType = typeof getLocation;

type UseLocationOptions = {
  locationId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useLocation = ({ locationId, config }: UseLocationOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['locations', locationId],
    queryFn: () => getLocation(locationId),
  });
};
